export enum ISocialPlatform {
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
  // INSTAGRAM_BASIC = 'instagramBasic',
  LINKEDIN = 'linkedin',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube',
  TELEGRAM = 'telegram',
  DISCORD = 'discord',
  TWITCH = 'twitch',
  PINTEREST = 'pinterest',
  SNAPCHAT = 'snapchat',
  SPOTIFY = 'spotify',
  ONLYFANS = 'onlyfans',
  // MEDIUM = 'medium',
  SUBSTACK = 'substack',
  BEEHIIV = 'beehiiv',
  IMDB = 'imdb',
  BEHANCE = 'behance',
}

export interface ISocialBase {
  platform: ISocialPlatform
  audience: number
  identifier: string
  isConfigured?: boolean
}

export interface ISocialVerifiedBase {
  platform: ISocialPlatform
  identifier: string
  audience: number
}

export interface ISocialVerified {
  [key: string]: ISocialVerifiedBase
}

export interface SocialConfigState {
  socials: ISocialBase[]
  isConfiguring?: boolean
  configuringSocial?: ISocialBase
  error?: string
  alertEmptySocials?: boolean
  loading?: boolean
}

export interface SocialConfigContextProps extends SocialConfigState {
  setSocial: (social: ISocialBase) => void
  removeSocial: () => void
  setConfiguringSocial: (social: ISocialPlatform) => void
  cancelConfiguringSocial: () => void
  saveSocials: (forceSave?: boolean) => void
  continueConfiguringSocial: () => void
}

export enum SocialConfigActionTypes {
  SET_SOCIALS = '[SocialConfig] Set Socials',
  SET_SOCIAL = '[SocialConfig] Set Social',
  REMOVE_SOCIAL = '[SocialConfig] Remove Social',
  SET_ERROR = '[SocialConfig] Set Error',
  SET_IS_CONFIGURING = '[SocialConfig] Set Is Configuring',
  SET_CONFIGURING_SOCIAL = '[SocialConfig] Set Configuring Social',
  SET_ALERT_EMPTY_SOCIALS = '[SocialConfig] Set Alert Empty Socials',
  SET_LOADING = '[SocialConfig] Set Loading',
}
